// API tour dates are calendar days encoded at midnight, not visitor-local instants.
function calendarParts(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/.exec(value);
  if (!match) return null;
  const [, year, month, day] = match;
  const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
  if (
    date.getUTCFullYear() !== Number(year) ||
    date.getUTCMonth() + 1 !== Number(month) ||
    date.getUTCDate() !== Number(day)
  )
    return null;
  return { year, month, day };
}

export function formatTourDateRange(start: string, stop: string): string {
  const first = calendarParts(start);
  const last = calendarParts(stop);
  if (!first || !last) return '-';
  return `${first.day}.${first.month}. - ${last.day}.${last.month}.${last.year}`;
}
